import EmptyState from "../EmptyState";
import { noAccessDescription, noAccessTitle } from "../../../_utils/permissionMessages";
import "./_no-access-state.scss";

/**
 * Full-page wrapper around `EmptyState`'s `noAccess` variant, so the "you
 * don't have access" wording is identical whether it's rendered by
 * `PermissionRoute` (whole page) or inline by a page that also needs the
 * denial state inside a `Table`'s `emptyState` slot.
 */
const NoAccessState = ({ moduleName }) => (
  <div className="no-access-state">
    <EmptyState noAccess title={noAccessTitle(moduleName)} desc={noAccessDescription} />
  </div>
);

export default NoAccessState;
